import React from "react";
import "./Sugar.css";
function Sugar() {
  return (
    <div className="sugarmain">
      <div className="sugar">
        <div className="sugarp">
          <p>Sugar Industries Application</p>
          <div>
            {/* <p className="p2">Swajit Engineering Pvt.Ltd. > Feedback</p> */}
          </div>
        </div>
        <div className="section1">
          <div className="video1">
            <p>Feeder Table for Cane Feeding Application</p>
            <iframe
              width="340"
              height="220"
              src="https://www.youtube.com/embed/KDev8zyX4Xo"
              title="Feeder Table for Cane Feeding Application-1"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
            ></iframe>
          </div>

          <div className="video2">
            <p>Cane Carrier Chain </p>
            <iframe
              width="340"
              height="220"
              src="https://www.youtube.com/embed/GlCRSSPfut8"
              title="2 Cane Carrier Chain"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
            ></iframe>
          </div>
        </div>
        <div className="section2">
          <div className="video3">
            <p>Laxivation Chain</p>
            <iframe
              width="340"
              height="220"
              src="https://www.youtube.com/embed/DaDmXSLVugE"
              title="Laxivation Chain Baggase Carrier Application -3"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
            ></iframe>
          </div>
          <div className="video4">
            <p>Rake Carrier Chain</p>
            <iframe
              width="340"
              height="220"
              src="https://www.youtube.com/embed/ZgrqsBPnhk0"
              title="4 Rake Carrier Chain"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Sugar;
